import React from 'react';
import clsx from 'clsx';
import 'focus-visible';
import { Icon } from '../../icon';
import { Typography } from '../../typography';
import { ListItemProvider } from './list-item-provider';
import { ListIcon } from './list-icon';
import { useListItem } from './use-list-item';
import styles from './styles.module.css';
import { Badge } from '../../badge';
/**
 * Компонент `<ListItem />` используется для создания элементов внутри `<List />`
 */
export function ListItem(props) {
  const {
    descriptionId,
    itemId,
    textid,
    description,
    text,
    children,
    iconLeft,
    selected,
    disabled,
    iconRight,
    adornmentRight,
    currentPadding,
    nextPadding,
    onClick,
    badgeValue,
    size,
    selectable,
    onKeyDown,
    isInteractive,
    value,
    iconSize
  } = useListItem(props);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    role: "presentation",
    className: clsx(styles.listItem, styles[size], props.className),
    ...(currentPadding && {
      style: {
        '--pad-start': currentPadding
      }
    })
  }, /*#__PURE__*/React.createElement("li", {
    id: itemId,
    onClick: onClick,
    role: selectable ? 'option' : 'listitem',
    tabIndex: isInteractive && !disabled ? 0 : undefined,
    onKeyDown: onKeyDown,
    "aria-labelledby": textid,
    "aria-describedby": descriptionId,
    "aria-selected": selectable ? selected : undefined,
    "aria-disabled": disabled,
    "data-testid": "listitem",
    "data-dom-listitem-value": value,
    "data-dom-listitem-type": typeof value,
    className: clsx(styles.listItemClickableContent, disabled && styles.disabled)
  }, /*#__PURE__*/React.createElement(Icon, {
    size: iconSize,
    className: styles.iconStart
  }, /*#__PURE__*/React.createElement(ListIcon, {
    disabled: disabled,
    selected: selected,
    icon: iconLeft
  })), /*#__PURE__*/React.createElement(Typography, {
    as: "div",
    id: textid,
    variant: size === 'l' ? 'm' : 's',
    size: "body_long",
    className: styles.title
  }, text, /*#__PURE__*/React.createElement("div", {
    className: styles.badge,
    role: "presentation"
  }, badgeValue && /*#__PURE__*/React.createElement(Badge, {
    type: "secondary",
    size: "m",
    value: badgeValue
  }))), /*#__PURE__*/React.createElement(Typography, {
    as: "div",
    id: descriptionId,
    variant: size === 'l' ? 'm' : 's',
    size: "body_short",
    className: styles.description
  }, description), /*#__PURE__*/React.createElement(Icon, {
    size: iconSize,
    className: styles.iconEnd
  }, /*#__PURE__*/React.createElement(ListIcon, {
    disabled: disabled,
    selected: selected,
    icon: iconRight
  }))), adornmentRight && (/*#__PURE__*/React.createElement("div", {
    className: clsx(styles.adornment, disabled && styles.disabled)
  }, adornmentRight))), children && /*#__PURE__*/React.createElement(ListItemProvider, {
    value: {
      nextPaddingStart: nextPadding
    }
  }, children));
}